var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_2038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 18.4286H3.33333C2.5996 18.4286 2 19.0074 2 19.7143C2 20.4212 2.5996 21 3.33333 21H20.6667C21.4004 21 22 20.4212 22 19.7143C22 19.0074 21.4004 18.4286 20.6667 18.4286ZM21.7031 7.60812C21.5371 7.50141 17.5775 4.97326 12.2337 3.04098C12.0827 2.98634 11.9173 2.98634 11.7663 3.04098C6.42253 4.97326 2.4629 7.50141 2.29687 7.60812C2.11133 7.72737 2 7.92826 2 8.14297V9.42867C2 9.78398 2.29883 10.0715 2.66667 10.0715H4V17.1429H8V10.0715H10V17.1429H14V10.0715H16V17.1429H20V10.0715H21.3333C21.7012 10.0715 22 9.78398 22 9.42867V8.14297C22 7.92826 21.8887 7.72737 21.7031 7.60812Z",
    fill: "#5D1CD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_2038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.da1511e95d18267f792a3893ea3731cf.svg";
export { ForwardRef as ReactComponent };